import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setOeeGrid = (state, { oeeGrid }) => {
  if (!oeeGrid) return state;
  return state.merge({ oeeGrid });
};
const setAssemblyLineGrid = (state, { oeeGrid }) => {
  if (!oeeGrid) return state;
  return state.merge({ oeeGrid });
};
const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
const isAssemblyDashboard = (state, { assemblyLine }) => {
  return state.merge({ assemblyLine });
};
const setSelectedGroups = (state, { selectedGroups }) => {
  return state.merge({ selectedGroups });
};
const setSelectedColumns = (state, { selectedColumns }) => {
  return state.merge({ selectedColumns });
};
const setShowFamilyProduction = (state, { showFamilyProduction }) => {
  return state.merge({ showFamilyProduction });
};
export const callbacks = [
  {
    actionType: ActionTypes.SET_OEE_GRID,
    actionFunction: setOeeGrid,
  },
  {
    actionType: ActionTypes.SET_ASSEMBLY_LINE_GRID,
    actionFunction: setAssemblyLineGrid,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.IS_ASSEMBLY_DASHBOARD,
    actionFunction: isAssemblyDashboard,
  },
  {
    actionType: ActionTypes.SET_SELECTED_GROUPS,
    actionFunction: setSelectedGroups,
  },
  {
    actionType: ActionTypes.SET_SELECTED_COLUMNS,
    actionFunction: setSelectedColumns,
  },
  {
    actionType: ActionTypes.SET_SHOW_FAMILY_PRODUCTION,
    actionFunction: setShowFamilyProduction,
  },
];
